import apiClient from '@u/apiClient'
import GetDossierNumberingByIdController from '@/wayfinder/actions/App/Http/Controllers/DossierNumbering/GetDossierNumberingByIdController'
import CreateDossierNumberingController from '@/wayfinder/actions/App/Http/Controllers/DossierNumbering/CreateDossierNumberingController'
import UpdateDossierNumberingController from '@/wayfinder/actions/App/Http/Controllers/DossierNumbering/UpdateDossierNumberingController'
import GetDossierNumberingListController from '@/wayfinder/actions/App/Http/Controllers/DossierNumbering/GetDossierNumberingListController'
import DeleteDossierNumberingController from '@/wayfinder/actions/App/Http/Controllers/DossierNumbering/DeleteDossierNumberingController'
export default {
  fetchDossierNumbering({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierNumberingByIdController.get({
            dossier_numbering: payload.dossier_numbering_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeDossierNumbering({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateDossierNumberingController.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateDossierNumbering({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierNumberingController.put({
            dossier_numbering: payload.dossier_numbering_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierNumberingsList({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierNumberingListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteDossierNumbering({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteDossierNumberingController.delete.delete({
            dossier_numbering: payload.dossier_numbering_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  undoDeleteDossierNumbering({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteDossierNumberingController.undo.get({
            id: payload.dossier_numbering_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
